<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row>
      <v-col
        v-for="(item, i) in info"
        :key="i"
        cols="12"
        class="pl-6"
      >
        <v-icon
          small
          class="mr-2"
        >
          {{ item.icon }}
        </v-icon>
        {{ item.value }}
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="template.qualityScore"
          outlined
          :items="scoreItems"
          label="Score"
          hide-details
        />
      </v-col>
      <v-col
        v-if="template.designGroup"
        cols="12"
      >
        <v-autocomplete
          v-model="template.designGroup.id"
          :items="design_groups"
          item-text="name"
          item-value="id"
          label="Design Group"
          hide-details="auto"
          outlined
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="template.mfgTypeId"
          outlined
          :items="mfg_types"
          label="Mfg Type"
          item-value="id"
          item-text="name"
          hide-details
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TemplateEditDetails',
  data: () => {
    return {
      scoreItems: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      valid: false
    };
  },
  computed: {
    template: {
      get() {
        return this.$store.getters['templates/edit_template'];
      },
      set(val) {
        this.$store.dispatch('templates/edit', val);
      }
    },
    info() {
      return [
        {
          icon: 'straighten',
          value: `${this.template.productName}${
            this.template.resizedFromTemplateId ? ' (Resized)' : ''
          }`
        },
        {
          icon: 'schedule',
          value: `Modified ${this.$options.filters.normalDateWithTime(this.template.modifiedDate)}`
        },
        {
          icon: 'event',
          value: `Created ${this.$options.filters.normalDateWithTime(this.template.createdDate)}`
        }
      ];
    },
    ...mapGetters({
      design_groups: 'lookup/design_groups',
      mfg_types: 'lookup/mfg_types'
    })
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.$emit('saving', true);
      this.$store
        .dispatch('templates/updateDetails', this.template)
        .then(() => {
          this.$root.$snackbarSuccess('Template saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.$emit('saving', false);
        });
    }
  }
};
</script>
